import { rem } from 'polished'
import { css } from 'styled-components'
import {
  CART_PANEL_DESKTOP_LAYOUT_MIN_WIDTH,
  CART_PANEL_MOBILE_CHECKBOX_GAP,
  CART_PANEL_MOBILE_HEADER_IMAGE_SIZE,
  CART_PANEL_MOBILE_TILE_PADDING,
} from './cartPanelConstants'

/** Mobile cart section titles align with the tile checkbox column (16px), per Figma. */
export const cartPanelMobileSectionHeaderPaddingStyles = css`
  padding-block: ${rem(12)};
  padding-inline: ${rem(CART_PANEL_MOBILE_TILE_PADDING)};
`

/** Scroll area is edge-to-edge on mobile so white tiles can span the drawer width. */
export const cartPanelMobileScrollContentStyles = css`
  padding-inline: 0;
  gap: 0;

  @container (min-width: ${rem(CART_PANEL_DESKTOP_LAYOUT_MIN_WIDTH)}) {
    gap: ${rem(16)};
  }
`

/** Trip cart tiles are flush to the drawer edges on mobile, matching user-cart / Figma. */
export const cartPanelMobileTileFullBleedStyles = css`
  border-radius: 0;

  @container (min-width: ${rem(CART_PANEL_DESKTOP_LAYOUT_MIN_WIDTH)}) {
    border-radius: ${props => props.theme.borderRadius?.S ?? rem(4)};
  }
`

export const cartPanelMobileTileRootStyles = css`
  position: relative;
  overflow: hidden;
  ${cartPanelMobileTileFullBleedStyles}
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
  width: 100%;

  &.deselected {
    opacity: 0.5;
  }

  &.clickable {
    cursor: pointer;
  }
`

export const cartPanelMobileTileHeaderStyles = css`
  display: grid;
  gap: ${rem(8)} ${rem(CART_PANEL_MOBILE_CHECKBOX_GAP)};
  align-items: start;
  padding-block-start: ${rem(CART_PANEL_MOBILE_TILE_PADDING)};
  padding-inline: ${rem(CART_PANEL_MOBILE_TILE_PADDING)};
  padding-block-end: ${rem(8)};
  grid-template-columns: minmax(0, 1fr);

  &.has-checkbox {
    grid-template-columns: auto minmax(0, 1fr);
  }

  &.with-image {
    grid-template-columns: minmax(0, 1fr) ${rem(CART_PANEL_MOBILE_HEADER_IMAGE_SIZE)};
  }

  &.has-checkbox.with-image {
    grid-template-columns: auto minmax(0, 1fr) ${rem(CART_PANEL_MOBILE_HEADER_IMAGE_SIZE)};
  }
`

export const cartPanelMobileHeaderImageStyles = css`
  width: ${rem(CART_PANEL_MOBILE_HEADER_IMAGE_SIZE)};
  height: ${rem(CART_PANEL_MOBILE_HEADER_IMAGE_SIZE)};
  border-radius: ${props => props.theme.borderRadius.M};
  overflow: hidden;

  img {
    border-radius: ${props => props.theme.borderRadius.M};
  }
`

export const cartPanelMobileTileBodyStyles = css`
  display: flex;
  flex-direction: column;
  gap: ${rem(12)};
  padding-inline: ${rem(CART_PANEL_MOBILE_TILE_PADDING)};
  padding-block-end: ${rem(CART_PANEL_MOBILE_TILE_PADDING)};
`

export const cartPanelMobileTileFooterStyles = css`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: ${rem(16)};
`

export const cartPanelMobileTileHoverStyles = css`
  transition: box-shadow 0.15s ease, transform 0.15s ease;

  &.clickable:hover {
    box-shadow: 0 ${rem(4)} ${rem(12)} rgba(0, 0, 0, 0.08);
    transform: translateY(-2px);
  }

  &.awaiting-fare {
    cursor: default;
  }
`

export const cartPanelTripCartLegPaddingStyles = css`
  padding-block: ${rem(CART_PANEL_MOBILE_TILE_PADDING)};
  padding-inline: ${rem(CART_PANEL_MOBILE_TILE_PADDING)};
`

export const cartPanelDesktopLegPaddingStyles = css`
  padding-block: ${rem(16)};
  padding-inline: ${rem(20)};
`

export const cartPanelTripCartDividerPaddingStyles = css`
  padding-inline: ${rem(CART_PANEL_MOBILE_TILE_PADDING)};
`

export const cartPanelDesktopDividerPaddingStyles = css`
  padding-inline: ${rem(20)};
`
